import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../../components/PageHeader";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import DiligenceListListType from "./subPages/list/DiligenceListListType";
import DiligenceListThumbType from "./subPages/list/DiligenceListThumbType";
import {useDispatch} from "react-redux";
import useRequestData from "../../../../hooks/useRequestData";
import {getDiligenceList} from "../../../../api/asset/DiligenceService";
import {addYears} from "date-fns";


function Diligence() {
    const [listType, setListType] = useState(true)
    const [checked,setChecked] = useState([]);
    const dp = useDispatch();

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }

    }, []);
    const { data, newData, pageInfo, dataHook} =
        useRequestData(getDiligenceList, initDate, 'diligence');

    return (
       <>
           <div className="common-container">
               <PageHeader
                   header={"자산실사관리"}
                   indicator={"자산관리 > 자산실사관리 > 자산실사목록"}
               />
               {(listType || isMobile) ?
                   <DiligenceListListType
                       data={newData}
                       date={initDate}
                       pageInfo={pageInfo}
                       dataHook={dataHook}
                       checked={{checked: checked, setChecked: setChecked}} />
                   :
                   <DiligenceListThumbType data={data} pageInfo={pageInfo} dataHook={dataHook} />
               }
           </div>
       </>
    );
}

export default Diligence;